module.exports = __webpack_public_path__ + "static/media/400027_02.47c037be.png";